export default "__VITE_ASSET__DaeGezSK__"